import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function Stats() {
  const stats = [{
    value: '45+',
    label: 'Active Projects'
  }, {
    value: '28',
    label: 'Member States Served'
  }, {
    value: '£180M',
    label: 'Total Investment'
  }, {
    value: '150+',
    label: 'Contracts Awarded'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <div className="bg-white py-16 border-b border-gray-100" data-id="element-266">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-267">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-268">
          {stats.map((stat, index) => <motion.div key={index} variants={itemVariants} className="flex flex-col items-center" data-id="element-269">
              <span className="text-4xl md:text-5xl font-serif font-bold text-au-green mb-2" data-id="element-270">
                {stat.value}
              </span>
              <span className="text-sm md:text-base text-gray-600 font-medium" data-id="element-271">
                {stat.label}
              </span>
            </motion.div>)}
        </motion.div>
      </div>
    </div>;
}